import { Button } from "antd";

export const BrokerAddScreen = () => {
    return (
        <>
            <h1>Broker Add</h1>
            <Button>Hello</Button>
        </>
    );
}